import { Grid, Image } from '@chakra-ui/react';
import { useContext } from 'react';
import {
    FormSection,
    FormSectionBody,
    FormSectionHeader,
    FormSectionTitle
} from '../../components/FormSection';
import { addonOffersContext } from '../../context/OfferAddonContext';
import { logos } from '../../utils/companiesLogos';
import { RecapExtraInsuranceTableRow } from './RecapExtraInsurance';


export const RecapExtraInsurance = () => {
    const { addonOffers } = useContext(addonOffersContext);

    const validAddonOffers = addonOffers?.filter(ao => ao.valid)

    if (validAddonOffers.length == 0)
        return null;

    return (
        <FormSection>
            <FormSectionHeader>
                <FormSectionTitle>Rekapitulace doplňkového pojištění</FormSectionTitle>
            </FormSectionHeader>

            <FormSectionBody>
                {validAddonOffers.map(ao => (
                    <Grid key={ao.offerId} sx={{ w: '100%' }}>
                        <RecapExtraInsuranceTableRow
                            image={<Image src={logos[ao.insurerId]} alt="Fortegra" width="64px" height="48px" />}
                            addonOffer={ao} />
                    </Grid>
                ))}
            </FormSectionBody>
        </FormSection>
    );
};
